export { default } from "ember-stereo/-private/utils/url-cache";
